import Vue from 'vue/dist/vue.esm';
import broughtGamesTable from 'components/events/games/brought_games_table.vue';

document.addEventListener('DOMContentLoaded', () => {
  const rawSearchParamsMaster = JSON.parse(document.getElementById('event-games').dataset.searchParamsMaster);
  const canBringGames = JSON.parse(document.getElementById('event-games').dataset.policyToggleBroughtGame);
  const eventID = JSON.parse(document.getElementById('event-games').dataset.eventId);

  new Vue({
    el: '#event-games',
    components: { broughtGamesTable },
    computed: {
      eventId: function() {
        return eventID;
      },
      searchParamsMaster: function() {
        return rawSearchParamsMaster;
      },
      canBringGames: function() {
        return canBringGames;
      }
    },
    template: `
      <div>
        <brought-games-table
          :eventId='eventId'
          :master='searchParamsMaster'
          :canBringGames='canBringGames'
        >
        </brought-games-table>
      </div>
    `
  });
});
